import { cn } from "@/lib/utils";

export function Wordmark({
  className,
  size = "md",
  ...rest
}: {
  className?: string;
  size?: "sm" | "md" | "lg" | "xl";
} & React.HTMLAttributes<HTMLSpanElement>) {
  const sizes = {
    sm: "text-lg",
    md: "text-xl",
    lg: "text-3xl",
    xl: "text-5xl sm:text-6xl",
  } as const;
  return (
    <span
      {...rest}
      className={cn(
        "wordmark inline-block whitespace-nowrap text-foreground",
        sizes[size],
        className,
      )}
    >
      L<span className="text-primary">∞</span>seEnd
      <span className="align-super text-[0.45em] tracking-normal">™</span>
    </span>
  );
}

export function InfinityMark({ className }: { className?: string }) {
  return (
    <span
      aria-hidden="true"
      className={cn(
        "wordmark grid size-8 shrink-0 place-items-center rounded-[10px] bg-primary-soft text-lg leading-none text-primary",
        className,
      )}
    >
      ∞
    </span>
  );
}
